/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import { AccountInfo, EndSessionRequest } from "@azure/msal-browser";

import { PublicClientApplication } from "@azure/msal-browser";
import { config } from "../config";

export const msalInstance = new PublicClientApplication(config.msalConfig);

export function getAccountDetails(): AccountInfo | null {
  const currentAccounts = msalInstance.getAllAccounts();
  if (currentAccounts == null) {
    return null;
  }
  return currentAccounts[0];
}

export function signOut(logoutRequest?: EndSessionRequest | undefined): void {
  msalInstance.logout(logoutRequest);
}

export async function getToken(): Promise<string | void> {
  const account = getAccountDetails();
  if (account) {
    const silentProfileRequest = {
      scopes: config.loginRequestScope.scopes,
      account: account,
      loginHint: account.username,
    };
    try {
      const resp = await msalInstance.acquireTokenSilent(silentProfileRequest);
      return resp.accessToken;
    } catch (e) {
      signOut();
    }
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getTokenClaimsFromAccountDetails(): any | null {
  const currentAccounts = msalInstance.getAllAccounts();
  if (currentAccounts == null) {
    return null;
  }
  return currentAccounts[0]?.idTokenClaims;
}
